module.exports = __webpack_public_path__ + "media/images/e-bilet/Kyiv__mobile__bg_new-bd5b905efe4d7f974284b0776693a692.webp";